import { Link } from "react-router-dom";
import NavButton from "../components/shared/NavButton";
import styles from "./BibliographyPageText.module.css";
//import ScrollTo from "react-scroll-into-view";
import bibliography from "../data/bibliography";
import { Markup } from 'interweave';

function BibliographyPageText() {
    return (
        <div className={styles.biblioContainer}>
            <div className={styles.biblioParagraphs}>
                {/*<div className={styles.biblioParagraph1} id="biblioParagraph1">

                    <div className={styles.biblioParagraphText}>
                        <p className={styles.paragraphNumber}>1/2</p>
                        <p>
                            Check-out the following resources to learn more about the research behind the exhibition.
                        </p>
                    </div>
                    <ScrollTo selector={`#biblioParagraph2`}>
                        <p className={styles.paragraphDownButton}>»</p>
                    </ScrollTo>

    </div>*/}
                <div className={styles.biblioParagraphText} id="biblioParagraph2">

                    <div className={styles.paragraphText}>
                        {/*<p className={styles.paragraphNumber}>2/2</p>*/}
                        <div className={styles.paragraphTitle}>
                            <br />
                            Reading List:
                            <br />
                            {
                                bibliography.map((book) => {
                                    return (
                                        <ul className={styles.readingList} key={book.id}>
                                            <li key={book.id} className={styles.readingListBook}>
                                                <a href={book.url} target="_blank" rel="noopener noreferrer" className={styles.bookUrl}>
                                                    {book.author}, <Markup content={book.title} />, {book.pubDate}
                                                </a>
                                            </li>
                                        </ul>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.biblioNavigationButtons}>
                <Link to="/about">
                    <NavButton navButtonLabel="About ›" />
                </Link>
                <Link to="/gallery">
                    <NavButton navButtonLabel="Gallery ›" />
                </Link>
                <Link to="/submissions">
                    <NavButton navButtonLabel="Submissions ›" />
                </Link>
                <Link to="/">
                    <NavButton navButtonLabel="Home ›" />
                </Link>
            </div>
        </div >

    )

}
export default BibliographyPageText;